import type { IconSvgObject } from './types';

const HologramIcon: IconSvgObject = [
  ["path", { d: "M17 19L15.3333 15M8.66667 15L7 19M12 16.3333V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 7V12.5874M12 7L7.37664 4.68832M12 7L16.6234 4.68832M7 4.5L12 2L17 4.5V10.5L12 13L7 10.5V4.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 22H21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default HologramIcon;
